export default {
  COMPNAME: "avue-echart-",
  NAME: "list",
  DEAFNAME: 'item',
  password: 'avue_data',
  systemPassword: 'qwer1234',
  shieldComponents: 'avue-echart-map,'
}
export const url = '/api/blade-visual'
// http://datav.xhngyl.cn